<template>
    <ui-modal :concatTitle="modalTitleComputed"
        :load="loader.loadModal"
        :loadSuccess="loader.modalLoadSuccess"
        name="marketing-integrations-facebook-create-integration-configuration"
        title="Configurações - "
        icon="fal fa-cogs"
        subtitle="Selecione as opções para a entrada de leads."
        size="xs"
        local
        closeOnOverlay>
        <div class="modal">
            <form class="form">
                <ui-select v-model="form.data.funnel_stage_id"
                    :load="loader.funnelStageLoading"
                    :show-default="funnelStageOptions.length ? false : true"
                    ref="stage-input-select"
                    label="Etapa do funil de vendas"
                    @input="stageInputHandler">
                    <option v-for="option in funnelStageOptions"
                        :key="option.id"
                        :value="option.id"
                        :selected="index == 0">
                        {{ option.name }}
                    </option>
                </ui-select>

                <ui-select v-model="form.data.funnel_stage_status_id"
                    :show-default="funnelStageStatusOptions.length ? false : true"
                    :load="loader.funnelStageStatusLoading"
                    label="Status do funil de vendas">
                    <option v-for="(status, index) in funnelStageStatusOptions"
                        :key="status.id"
                        :value="status.id"
                        :selected="index == 0">
                        {{ status.name }}
                    </option>
                </ui-select>

                <ui-select2 :data="leadOptions"
                    label="Fila de distribuição de leads"
                    item-label="name"
                    @input="leadsInputHandler" />

                <ui-button :disabled="isDisabledBtnSaveComputed"
                    design="lg block success"
                    @click="addIntegration">
                    Adicionar Integração
                </ui-button>
            </form>
        </div>
    </ui-modal>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"
    import { uiModal } from "@/components/ui/modal"
    import { uiSelect, uiSelect2 } from '@/components/ui/form'
    import { funnel , lead, facebook } from '@/services/axios'
    import { mapGetters } from 'vuex'
	import axios from 'axios'

	/** Objeto com os dados que vão ser usadados para atualizar o fbLeadsConfigs */
	let defaultFormData = () => {
		return {
			account: null,
            form: null,            
            page: null,
			leads: null,
            funnel_stage_id: null,
            funnel_stage_status_id: null,
		}
	}

    const defaultLoader = () => {
        return {
            loadModal: false,
            modalLoadSuccess: false,
            funnelStageLoading: false,
            funnelStageStatusLoading: false,
            leadLoading: false
        }
    }

    export default {
        components: {
            uiButton,
            uiModal,
            uiSelect,
            uiSelect2
        },

        props: {
            user: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            }
        },

        data() {
            return {
                loader: { ...defaultLoader() },
				form: {
                    data: { ...defaultFormData() }
                },
                funnelStageOptions: [],
                funnelStageStatusOptions: [],
                leadOptions: [],
                isDisabledBtnSave: true
            }
        },

        created() {
            /**
             * Ao Abrir o modal pela primeira vez 'seta' os parametros iniciais de carregamento/loading
             */
            this.$root.$on('modal-open-marketing-integrations-facebook-create-integration-configuration', () => {
                this.loadData()
                this.resetLoader()
			})
            /**
             * Ao fechar o modal reseta o estado do formulário
             */
            this.$root.$on('modal-close-marketing-integrations-facebook-create-integration-configuration', () => {
                this.resetForm()
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-marketing-integrations-facebook-create-integration-configuration')
            this.$root.$off('modal-close-marketing-integrations-facebook-create-integration-configuration')
        },

        computed: {
            ...mapGetters('facebook', {
                accountSelected: 'getConfigurationAccount',
                pageSelected: 'getConfigurationPage',
                formSelected: 'getConfigurationForm',
            }),
            /**
             * Computed property que retorna o título do formulário
             */
            modalTitleComputed() {
                return this.form.data && this.form.data.form ? `Form: ${this.form.data.form.id}` : ''
            },
            /**
             * Computed property que define se é permitido ou não salvar os dados
             */
            isDisabledBtnSaveComputed() {
                return !this.form.data.account ||
                    !this.form.data.form ||
                    !this.form.data.page ||
                    !this.form.data.leads ||
                    !this.form.data.funnel_stage_id
            }
        },

        methods: {
            /**
             * Emite um evento no root para fechar o modal
             */
            close() {
                this.$root.$emit('modal-close-marketing-integrations-facebook-create-integration-configuration')
            },
            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = {...defaultLoader()}
            },
            /**
             * Reseta os dados do formulário
             */
            resetForm() {
                this.funnelStageOptions = []
                this.funnelStageStatusOptions = []
                this.leadOptions = []
                this.$set(this.form, 'data', { ...defaultFormData() })
                this.loader = { ...defaultLoader() }
            },
            /**
             * Emite um evento no root para fechar o modal
             */
            addIntegration: async function () {
                this.$set(this.loader, 'loadModal', true)

                let params = {
                    facebook_account_id: this.form.data.account.id,
                    page_id: this.form.data.page.id,
                    page_token: this.form.data.page.access_token,
                    page_name: this.form.data.page.name,
                    form_id: this.form.data.form.id,
                    form_name: this.form.data.form.name,
                    leads_id: this.form.data.leads.id,
                    funnel_stage_id: this.form.data.funnel_stage_id,
                    user_id: this.user.id
                }

                if (this.form.data.funnel_stage_status_id) {
                    params.funnel_stage_status_id = this.form.data.funnel_stage_status_id
                }
                await facebook.create('', params).then(response => {
                    this.$toastr.s(response.data.msg)

                    this.$set(this.loader, 'loadModal', false)

                    setTimeout(() => {
                        this.close()
                        this.$emit('integration-success')
                    }, 404)
                }).catch((err) => {
                    if (err.data.status == 'error') {
                        this.$set(this.loader, 'loadModal', false)
                        this.$root.$emit('modal-close-marketing-integrations-facebook-create-integration')
                        this.$root.$emit('alert-msg-open-erro-integration-facebook')
                    }
                })
            },
			/**
			 * Carrega o select de status de acordo com a etapa selecionada
			 */
			loadStageStatusOptions(stageId) {
                this.$set(this.loader, 'funnelStageStatusLoading', true)
				this.funnelStageStatusOptions = []
				let stage = Object.values(this.funnelStageOptions).find(stage =>  stage.id === parseInt(stageId))

				if (stage && stage.status.length) {
                    this.funnelStageStatusOptions = [...stage.status]
                    this.$set(this.form.data, 'funnel_stage_status_id', this.funnelStageStatusOptions[0].id)
                }

				this.$set(this.loader, 'funnelStageStatusLoading', false)
			},
			/**
			 * Handler que trata o evento de quando uma Etapa é selecionada
			 */
			stageInputHandler() {
				this.loadStageStatusOptions(this.form.data.funnel_stage_id)
			},
            /**
             * Handler que trata o evento de quando um Lead é selecionado
             */
            leadsInputHandler(lead) {
                if (!Array.isArray(lead)) this.$set(this.form.data, 'leads', lead)
            },
			/**
			 * Carrega os dados do formulário
			 */
			loadData: async function () {
                try {
                    /** Gera o token para cancelar as requisições */
                    const CancelToken = axios.CancelToken
                    const source = CancelToken.source()
                    const config = { cancelToken: source.token }
                    
                    this.$set(this.loader, 'funnelStageLoading', true)
                    this.$set(this.loader, 'leadLoading', true)
                    this.$set(this.form.data, 'account', { ...this.accountSelected })
                    this.$set(this.form.data, 'page', { ...this.pageSelected })
                    this.$set(this.form.data, 'form', { ...this.formSelected })

                    /** Busca os dados das etapas cadastradas */
                    let response = await funnel.getStages(config)
                    this.funnelStageOptions = [...response.data]
                    if (this.funnelStageOptions.length) {
                        this.$set(this.form.data, 'funnel_stage_id', this.funnelStageOptions[0].id)
                        this.stageInputHandler()
                    }

                    response = await lead.getAll('', {}, config)
                    this.leadOptions = Object.values(response.data).map(lead => {
                        lead.name = `${lead.id} - ${lead.name}`

                        return lead
                    })

                } catch (error) {
                    if (error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.$set(this.loader, 'funnelStageLoading', false)
                    this.$set(this.loader, 'leadLoading', false)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>